import axios from '@apis/spring-client';
import { GetCategoryListData } from 'models/swagger-spring/data-contracts';
import { useQuery } from 'react-query';

export const getUserInterestCategory = async (): Promise<GetCategoryListData> => {
  try {
    const response = await axios.get(`/api/user/interest-info-category`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const useGetUserInterestCategory = () => {
  return useQuery(['getUserInterestCategory'], () => getUserInterestCategory());
};

export default useGetUserInterestCategory;
